function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 10a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM8 16.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0zm7-3.5v-1.5h1V13h2v1h-4v2h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1v1.5h-1V20h-2v-1h4v-2h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.612b77c4801e7d98c404ec6a3ece394c.svg";
export { ForwardRef as ReactComponent };